import { analyticsProperties, ModalEventKeys, DefaultSourceKeys, PaywallEventKeys, PwaEventKeys } from "./modules";
import type { BaseEvent } from "@amplitude/analytics-types";

export type AnalyticsEventInputAllTypes = ModalEventKeys | PaywallEventKeys | PwaEventKeys;
export type AnalyticsEventAllSources = DefaultSourceKeys;

export type AnalyticsEventInput = AnalyticsEventInputAllTypes | BaseEvent | string;

const { source, component } = analyticsProperties;

export interface AnalyticsEventProperties {
  [source]?: AnalyticsEventAllSources,
  [component]?: string,
}